module.exports = __webpack_public_path__ + "static/media/catalyst-bg-1.60736c1f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/catalyst-bg-1.svg
// module id = 1122
// module chunks = 0